import React, { useState, useContext, useEffect, useRef } from 'react'
import { Selected } from '../../../context/context'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.scss';
import './custom.css'
import {
    Card, //CAMBIAR ESTO PARA DARLE ESTILOS A LAS TARJETAS MOBILE
    CardTitle,
    Feature,
} from './Elements'
import {
    MobileContainer, 
    MobileTitle,
    MobileInner,
    MobileListViewer,
} from './MobileElements'
import { tecnicas } from './content'

const Producto = () => {

    const [ selected, setSelected ] = useContext(Selected)

    const handleClick = (tecnica) => {
        setSelected({...selected, tecnica: tecnica})
    }

    return(
        <MobileContainer>
            <MobileTitle>Seleccioná el tipo de personalizado</MobileTitle>
            <MobileInner
            // variants={mobileMotion}
            // initial="initial"
            // animate="animate"
            // exit="exit"
            >
                <MobileListViewer>
                    <Swiper
                        slidesPerView='auto'
                        // style={{'height': '20rem'}}
                    >
                        {
                            tecnicas.length > 0 &&
                            tecnicas.map(item => {
                                return(
                                    <SwiperSlide
                                    key={item.title}
                                    className='swiper-slide-container'
                                    >
                                        <Card
                                            // variants={cardMotion}
                                            to='/producto'
                                            onClick={() => handleClick(item.tech)}
                                            key={item.title}
                                            background={item.img}
                                        >
                                            <CardTitle>
                                                {item.title}
                                            </CardTitle>
                                            {
                                                item.properties.map(item => {
                                                    return <Feature>{item}</Feature>
                                                })
                                            }
                                        </Card>
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>
                </MobileListViewer>
            </MobileInner>
        </MobileContainer>
    )
}

export default Producto